const setSpouseLifeLongCitizenId = (val = null) => {
  return {
    type: 'SET_SPOUSELIFELONGCITIZENID',
    data: val,
  }
}

export default {
  setSpouseLifeLongCitizenId,
}
